<div [formGroup]="form">
  <nx-edit-select-input
    [showLabel]="showLabel()"
    [panelWidhtFull]="true"
    formControlName="selected"
    [filter]="true"
    [options]="options"
    [onFilter]="onFilter"
    [placeholder]="placeholder()"
    [showClear]="true"
    [label]="label()"
    optionLabel="name">
  </nx-edit-select-input>
</div>
